'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionWrapper = function AccordionWrapper(_ref) {
    var listItem = _ref.listItem,
        children = _ref.children,
        className = _ref.className;
    return listItem ? _react2.default.createElement("li", { className: className }, children) : _react2.default.createElement("div", { className: className }, children);
};
AccordionWrapper.propTypes = {
    className: _propTypes2.default.string.isRequired,
    listItem: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.node.isRequired
};
exports.default = AccordionWrapper;
//# sourceMappingURL=AccordionWrapper.js.map